import Home from '../pages/Home'
import Contact from '../pages/Contact'
import BrahmaJyotiAgroFarm from '../pages/BrahmaJyotiAgroFarm'
import BrahmaJyotiFinancialSolution from '../pages/BrahmaJyotiFinancialSolution'
import BrahmaJyotiGreenEnergy from '../pages/BrahmaJyotiGreenEnergy'
import NoticeBoard from '../pages/NoticeBoard'
import Gallery from '../pages/Gallery'
import ManagementTeam from '../pages/ManagementTeam'
import Careers from '../pages/Careers'
import Portfolio from '../pages/Portfolio'
import Overview from '../pages/About/Overview'
import StrategicObjectives from '../pages/About/StrategicObjectives'
import CorporateGovernance from '../pages/About/CorporateGovernance'
import LegalDocuments from '../pages/About/LegalDocuments'
import Individual from '../pages/ApplyShare/Individual'
import Company from '../pages/ApplyShare/Company'
import Projects from '../pages/Projects/Index'
import ProjectsDetails from '../pages/ProjectDetails/Index'
export const ROUTELIST = [
    {
        id: 1,
        path: "/",
        element: <Home/>,
        name: "Home"
    },
    {
        id: 2,
        name: "About Us",
        children: [
            {
                path: "/overview",
                element: <Overview/>,
                name: "Overview"
            },
            {
                path: "/strategicobjectives",
                element: <StrategicObjectives/>,
                name: "Strategic Objectives"
            },
            {
                path:"/corporategovernance",
                element: <CorporateGovernance/>,
                name:"Corporate Governance"
            },
            {
                path:"/legaldocuments",
                element: <LegalDocuments/>,
                name:"Legal Documents"
            },
      ]
    },
  
    {
        id: 3,
        name: "Portfolio & Investment",
        children: [
            {
               
                path:"/portfolio",
                element: <Portfolio/>,
                name:"Portfolio"
            },
            {
                path: "/brahmajyotiagrofarm",
                element: <BrahmaJyotiAgroFarm/>,
                name: "Brahma Jyoti Multi Agro Farm"
            },
            {
                path: "/brahmajyotigreenenergy",
                element: <BrahmaJyotiGreenEnergy/>,
                name: "Brahma Jyoti Green Energy"
            },
            {
                path:"/brahmajyotifinancial",
                element: <BrahmaJyotiFinancialSolution/>,
                name:"Brahma Jyoti Investment and Equity Management"
            },
            
      ]
    },
   
    // {
    //     id: 5,
    //     path:"/applyshare",
    //     element: <ApplyShare/>,
    //     name:"Join Us"
    // },
    {
        id: 6,
        path: "/projects",
        element: <Projects/>,
        name: "Projects"
    },
  
   
    {
        id: 8,
        path: "/managementteam",
        element: <ManagementTeam/>,
        name: "Management Team"
    },
    {
        id: 9,
        path: "/gallery",
        element: <Gallery/>,
        name: "Gallery"
    },
    {
        id: 10,
        path:"/noticeboard",
        element: <NoticeBoard/>,
        name:"Media & Notice"
    },
    {
        id: 11,
        name: "Join Us",
        children: [
            {
                path: "/individual",
                element: <Individual/>,
                name: "Individual Share"
            },
            {
                path: "/company",
                element: <Company/>,
                name: "Company Share"
            },
            
        ] 
    },
    {
        id : 12,
        path:"/contact",
        element: <Contact/>,
        name:"Contact"
    },
    {
        id: 13,
        path:"/careers",
        element: <Careers/>,
        name:"Careers"
    },
   
]
